/*
 * Created by alex@hackerbay.com on 3.1.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */

import * as React from "react";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {translate} from "react-i18next";
import i18n from "i18next";
import {Button, Col, Row} from "reactstrap";

import iconCalendarAdd from "../media/icons/calendar-add.png"
import DownloadCalendarFileLink from "../pages/DownloadCalendarFileLink";

class FullWidthSaveToCalendarButton extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        const downloadButton = <Button
            className={"button-gray w-100"}
            style={{height:"48px"}}>
            <Row>
                <Col xs={2}>
                    <img src={iconCalendarAdd} height={"28px"} style={{marginTop:"-4px"}}/>
                </Col>
                <Col xs={10} style={{paddingLeft:"0px",textAlign:"left"}}>
                    {i18n.t("save_reminder_to_calendar")}
                </Col>
            </Row>
        </Button>;

        return <Row style={{marginTop:"16px"}}>
            <Col>
                <DownloadCalendarFileLink
                    urlIdent={this.props.urlIdent}
                    text={downloadButton}
                />
            </Col>
        </Row>
    }
}

export default translate("translations")(FullWidthSaveToCalendarButton);